/**
 * Number formatting that always renders Western ("Latin") digits.
 *
 * `NumberFormatter` from @eduact/utils passes `document.documentElement.lang`
 * straight to `Intl.NumberFormat`, so in Arabic every figure came out in
 * Arabic-Indic digits — the wallet read ١٠٩ instead of 109. The product wants
 * Western digits in both languages, so the locale still decides grouping and
 * decimal separators while the numbering system is pinned to `latn`.
 *
 * Import this instead of the @eduact/utils one.
 */
const NumberFormatter = (number: number | string, options?: Intl.NumberFormatOptions): string => {
	const value = Number(number)
	if (Number.isNaN(value)) throw new Error('Invalid number')
	// Drop any numbering system already on the tag before pinning our own, so
	// this stays correct if the lang attribute ever carries a -u- extension.
	const locale = (document.documentElement.lang || 'en-GB').split('-u-')[0]
	return new Intl.NumberFormat(`${locale}-u-nu-latn`, options).format(value)
}

export default NumberFormatter
export { NumberFormatter }
